import React from "react";
import { FONT_GROUPS } from "./designSystemDefaults";

const WEIGHT_OPTIONS = [
    { value: "400", label: "Regular (400)" },
    { value: "500", label: "Medium (500)" },
    { value: "600", label: "Semibold (600)" },
    { value: "700", label: "Bold (700)" },
    { value: "800", label: "Extra Bold (800)" },
];

const SIZE_OPTIONS = ["14px", "15px", "16px", "17px", "18px"];

export default function DesignSystemTypography({ typography, onChange }) {
    const handleChange = (key, value) => {
        onChange({ ...typography, [key]: value });
    };

    return (
        <div className="space-y-5">
            <h3 className="text-sm font-semibold">Typography</h3>
            <div className="space-y-4">
                <div>
                    <label className="text-sm font-medium">Font Family</label>
                    <select
                        value={typography?.fontFamily || FONT_GROUPS[0].fonts[0]}
                        onChange={(e) => handleChange("fontFamily", e.target.value)}
                        className="block w-full mt-1 px-3 py-2 border border-input rounded-md bg-background text-sm"
                    >
                        {FONT_GROUPS.map((group) => (
                            <optgroup key={group.label} label={group.label}>
                                {group.fonts.map((font) => (
                                    <option key={font} value={font}>{font.split(",")[0]}</option>
                                ))}
                            </optgroup>
                        ))}
                    </select>
                    <p className="text-xs text-muted-foreground mt-1" style={{ fontFamily: typography?.fontFamily || FONT_GROUPS[0].fonts[0] }}>
                        The quick brown fox jumps over the lazy dog
                    </p>
                </div>
                <div className="grid grid-cols-2 gap-4">
                    <div>
                        <label className="text-sm font-medium">Heading Weight</label>
                        <select value={typography?.headingWeight || "700"} onChange={(e) => handleChange("headingWeight", e.target.value)} className="block w-full mt-1 px-3 py-2 border border-input rounded-md bg-background text-sm">
                            {WEIGHT_OPTIONS.map((w) => <option key={w.value} value={w.value}>{w.label}</option>)}
                        </select>
                    </div>
                    <div>
                        <label className="text-sm font-medium">Body Text Size</label>
                        <select value={typography?.bodySize || "16px"} onChange={(e) => handleChange("bodySize", e.target.value)} className="block w-full mt-1 px-3 py-2 border border-input rounded-md bg-background text-sm">
                            {SIZE_OPTIONS.map((s) => <option key={s} value={s}>{s}</option>)}
                        </select>
                    </div>
                </div>
            </div>
        </div>
    );
}
